import { Fragment,useState, useEffect, useTransition } from 'react'
import {Terminal} from 'primereact/terminal'
import {TerminalService} from 'primereact/terminalservice';
const Console = ({title, submitter }) => {

   const [consoleData, setConsoleData] = useState<string>("> Welcome...")
   const [error, setError] = useState<string|null>(null)
   const [pending, startTransition] = useTransition();

   const appendConsole = (line) => {
   	 console.log('appendCOnsole',line)
         setConsoleData( consoleData + "\n" + line );
   }

   const commandHandler = async (cmd)=>{
      console.log("Handler"+cmd);
      let answer = "Generic Error";
      //request
      try {
        setError(null);
        const response = await fetch(ENDPOINT+"/webconsole",
				{
					method: 'POST',		
		 			headers:{'Content-Type':'application/json'},
					body: JSON.stringify({key: "command", value: cmd})
        			});
        if (!response.ok){
	   answer =  'Fehler beim Laden';
	}else{
	        const data = await response.json();
		console.log("Data",data)
        	answer = ">" + cmd + "\n" + JSON.stringify(data);
        }
      } catch (err) {
      	console.log('error'+err);
        answer = 'error'+err;
      }
      // end of request
      console.log("Answer:" + answer)
      TerminalService.emit('response',answer);
   };
   useEffect(()=>{
   TerminalService.on('command',commandHandler);
       return () => {
            TerminalService.off('command', commandHandler);
        };
	});
	


   return (<><h2>OSM Road Monitor Cloud Console</h2>
   <p>
</p>
<Terminal 
    welcomeMessage="Welcome to SSDI Cloud Console" 
    prompt="backend $" 
    pt={{
        root: 'terminalroot',
        prompt: 'terminalprompt',
        command: 'terminalcommand',
        response: 'terminalresponse'
    }} 
/>
</>);
};
export default Console;